import { createContext } from 'react';
import { ToastContextProps } from './types';

const defaultToastContext: ToastContextProps = {
  openToast: ({ message }) => {
    console.info('Toast message:', message);
  },
};

const ToastContext = createContext<ToastContextProps>(defaultToastContext);

export default ToastContext;
